import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../root-route";
import { LegalPage } from "./legal";
import { MyDataPage } from "./my-data";

/**
 * Routes posees par le template : pages legales et « Mes données ». Elles existent
 * dans toutes les apps du Lab, a la meme adresse, et l'app n'a pas a les declarer.
 *
 * Les adresses sont figees ici et dans `legalDocument()` cote `@app/shared` : les
 * changer casserait les liens deja publies (pied de page, Stripe, e-mails).
 */

export const mentionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/mentions-legales",
  component: () => LegalPage({ id: "mentions" }),
});

export const confidentialiteRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/confidentialite",
  component: () => LegalPage({ id: "confidentialite" }),
});

export const cguRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cgu",
  component: () => LegalPage({ id: "cgu" }),
});

/**
 * Toujours declaree, meme sans l'option `billing` : la route existe, et la page dit
 * alors qu'elle ne concerne pas cette app. Une route conditionnelle rendrait le
 * pied de page et le routeur dependants d'un drapeau, pour rien.
 */
export const cgvRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cgv",
  component: () => LegalPage({ id: "cgv" }),
});

export const myDataRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/mes-donnees",
  component: MyDataPage,
});

export const labRoutes = [mentionsRoute, confidentialiteRoute, cguRoute, cgvRoute, myDataRoute];
